var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAddsong(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2692",
    "data-name": "Group 2692",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.037,
    height: 22.393,
    viewBox: "0 0 24.037 22.393",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_991",
    "data-name": "Rectangle 991",
    width: 24.037,
    height: 22.393,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2691",
    "data-name": "Group 2691",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2716",
    "data-name": "Path 2716",
    d: "M0,.628A.99.99,0,0,1,1.021,0Q6.037.01,11.054,0a.882.882,0,0,1,.971.951.86.86,0,0,1-.794.812c-.07,0-.141,0-.211,0Q6,1.77.988,1.774A.95.95,0,0,1,0,1.144Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2717",
    "data-name": "Path 2717",
    d: "M0,77.34a.933.933,0,0,1,.962-.63q5.075.011,10.151,0a.88.88,0,0,1,.728,1.426.9.9,0,0,1-.761.342H8.641c-2.54,0-5.079,0-7.619,0A1,1,0,0,1,0,77.856Z",
    transform: "translate(0 -71.551)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2718",
    "data-name": "Path 2718",
    d: "M134.053,8.594q0-3.694,0-7.388a.924.924,0,0,1,.5-.912.832.832,0,0,1,1.2.52,5.558,5.558,0,0,0,1.41,2.211,8.81,8.81,0,0,0,1.521,1.209,15.139,15.139,0,0,1,2.241,1.694,5.668,5.668,0,0,1,1.706,4.836,8.659,8.659,0,0,1-1.8,4.509.89.89,0,0,1-1.3.223.871.871,0,0,1-.106-1.288.956.956,0,0,0,.168-1.024,6.088,6.088,0,0,0-3.522-3.94c-.251-.112-.254-.108-.254.162,0,3.1-.025,6.208.01,9.312a3.321,3.321,0,0,1-1.924,3.227,4.914,4.914,0,0,1-5.38-.364,2.984,2.984,0,0,1-1.339-2.437,2.85,2.85,0,0,1,.757-2.014,4.5,4.5,0,0,1,2.931-1.462,4.9,4.9,0,0,1,3.01.565c.226.122.166-.059.166-.156q0-3.237,0-6.474V8.594M128.96,19.1a1.458,1.458,0,0,0,.814,1.2,3.242,3.242,0,0,0,2,.447,2.988,2.988,0,0,0,1.689-.615,1.237,1.237,0,0,0-.006-2.1,3.393,3.393,0,0,0-3.766-.109,1.457,1.457,0,0,0-.727,1.174m6.9-14.855a.336.336,0,0,0-.036.238c0,.813.009,1.626-.008,2.438a.378.378,0,0,0,.306.432,8.287,8.287,0,0,1,3.812,2.7,9.283,9.283,0,0,1,.805,1.233,4.075,4.075,0,0,0,.136-.786,3.853,3.853,0,0,0-.709-2.746,6.36,6.36,0,0,0-1.682-1.512c-.666-.465-1.357-.9-1.977-1.424-.218-.185-.429-.378-.647-.571",
    transform: "translate(-118.633 -0.182)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2719",
    "data-name": "Path 2719",
    d: "M50.362,131.531c0-.864,0-3.073,0-3.937a.853.853,0,0,1,.82-.949.868.868,0,0,1,.858.925c.011.99,0,3.325,0,4.315q0,1.107,0,2.215a.932.932,0,0,1-.417.864.761.761,0,0,1-.833.03.791.791,0,0,1-.43-.719c0-.914,0-1.829,0-2.743",
    transform: "translate(-46.974 -118.128)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2720",
    "data-name": "Path 2720",
    d: "M3.541,178.69q-1.3,0-2.592,0A.853.853,0,0,1,0,177.87a.868.868,0,0,1,.925-.858c.99-.011,1.98,0,2.97,0,.738,0,2.822,0,3.56,0a.933.933,0,0,1,.864.417.761.761,0,0,1,.03.833.791.791,0,0,1-.719.43c-.914,0-3.174,0-4.088,0",
    transform: "translate(0 -165.103)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddsong);
export default __webpack_public_path__ + "static/media/icon_addsong.1d28cb3c90b5f8f7f5d8b8450adfe3b7.svg";
export { ForwardRef as ReactComponent };